import { URLS, resolvePublicServiceUrl } from "@itaas/ports";

export const ISC_API_BASE_URL =
  import.meta.env.VITE_ISC_API_BASE_URL ?? "/api/isc";

export const ISC_TENANT_SLUG =
  import.meta.env.VITE_IAM_TENANT_SLUG ?? "demo-hospitol";

export const ISC_WEB_URL = resolvePublicServiceUrl(
  import.meta.env.VITE_INVENTORY_URL,
  "VITE_INVENTORY_URL",
  URLS.INVENTORY_WEB,
);
